// Import CSS styles for the "Footer" component
import myStyle from "./footer.module.css";

// Import Chakra UI components for creating lists
import { Box, Flex, Icon, Text } from "@chakra-ui/react";

import SocialSvg from "../svg/SocialSVG";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Flex
      as={"footer"}
      position={"relative"}
      bottom={0}
      direction={{ base: "column", md: "row" }}
      justifyContent={{ xl: "space-between" }}
      align={{ base: "flex-start", md: "center" }}
      p={{ base: "2em 1.3em", xl: "2.5rem 1.5rem" }}
      className={myStyle.footer}
    >
      {/* Left section of the footer */}
      <Box>
        <Text>Controluce illuminazione di Monti Daniele</Text>
        <Text>Partita IVA: 04758120481</Text>
        <Text>
          Codice Fiscale e N° iscrizione al registro delle imprese:
          MNTDNL59T29D612G
        </Text>
        <Text>N° REA: FI 476078</Text>
        <Text
          textDecor={"none"}
          _hover={{ color: "ambra" }}
          display={{ xl: "inline" }}
        >
          <Link
            target="_blank"
            to="https://www.google.it/maps/place/Controluce+Illuminazione/@43.7583291,11.1626199,18z/data=!4m9!1m2!2m1!1svia+di+casellina,+snc+Isola+E+Interno+Piano+Terra+scandicci+firenze!3m5!1s0x132a57fa612271ed:0x2a2fe1ce1134cf45!8m2!3d43.7584444!4d11.1627486!16s%2Fg%2F1hc6xpxd3?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D"
          >
            Sede legale: Scandicci(FI), Via di casellina snc, CAP 50018, Isola e
            interno piano terra, stradario 06680, Italia.
          </Link>
          <Icon
            m={{
              base: "0.1em 0 0 0.3em",
            }}
            viewBox="0 0 24 24"
          >
            {" "}
            {/* TODO: RISOLVI PROBLE COLORE */}
            <path
              d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
              fill="rgba(255,191,0, 0.5)"
            />
            <path
              d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
              fill="rgba(255,191,0, 0.5)"
            />
          </Icon>
        </Text>
        <Box mt={{ xl: "1em" }}>
          <Text
            textDecor={"none"}
            _hover={{ color: "ambra" }}
            display={{ xl: "inline" }}
          >
            <a
              href="https://www.iubenda.com/privacy-policy/20133443"
              className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
              title="Privacy Policy "
            >
              Privacy Policy
            </a>{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/20133443/cookie-policy"
              className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe "
              title="Cookie Policy "
            >
              Cookie Policy
            </a>
            {/* <Link to="/info">Privacy policy - Termini e condizioni</Link> */}
            <Icon
              m={{
                base: "0.1em 0 0 0.3em",
              }}
              viewBox="0 0 24 24"
            >
              {" "}
              {/* TODO: RISOLVI PROBLE COLORE */}
              <path
                d="M15.7285 3.88396C17.1629 2.44407 19.2609 2.41383 20.4224 3.57981C21.586 4.74798 21.5547 6.85922 20.1194 8.30009L17.6956 10.7333C17.4033 11.0268 17.4042 11.5017 17.6976 11.794C17.9911 12.0863 18.466 12.0854 18.7583 11.7919L21.1821 9.35869C23.0934 7.43998 23.3334 4.37665 21.4851 2.5212C19.6346 0.663551 16.5781 0.905664 14.6658 2.82536L9.81817 7.69182C7.90688 9.61053 7.66692 12.6739 9.51519 14.5293C9.80751 14.8228 10.2824 14.8237 10.5758 14.5314C10.8693 14.2391 10.8702 13.7642 10.5779 13.4707C9.41425 12.3026 9.44559 10.1913 10.8809 8.75042L15.7285 3.88396Z"
                fill="rgba(255,191,0, 0.5)"
              />
              <path
                d="M14.4851 9.47074C14.1928 9.17728 13.7179 9.17636 13.4244 9.46868C13.131 9.76101 13.1301 10.2359 13.4224 10.5293C14.586 11.6975 14.5547 13.8087 13.1194 15.2496L8.27178 20.1161C6.83745 21.556 4.73937 21.5863 3.57791 20.4203C2.41424 19.2521 2.44559 17.1408 3.88089 15.6999L6.30473 13.2667C6.59706 12.9732 6.59614 12.4984 6.30268 12.206C6.00922 11.9137 5.53434 11.9146 5.24202 12.2081L2.81818 14.6413C0.906876 16.5601 0.666916 19.6234 2.51519 21.4789C4.36567 23.3365 7.42221 23.0944 9.33449 21.1747L14.1821 16.3082C16.0934 14.3895 16.3334 11.3262 14.4851 9.47074Z"
                fill="rgba(255,191,0, 0.5)"
              />
            </Icon>
          </Text>
        </Box>
        <Text mt={{ base: "1em" }}>
          Controluce illuminazione &copy; 2026 All rights Reserved
        </Text>
      </Box>
      {/* Right section of the footer */}
      <Box ml={{ base: "-1em", xl: "0" }}>
        <SocialSvg />
      </Box>
    </Flex>
  );
};

export default Footer;
